import React, { FC, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Choice } from '~Scenes/SelfServiceKiosks/Scenes/Item';
import { Row, Price } from '../Basket';
import Text from '~Scenes/SelfServiceKiosks/Components/Text';
import { useCurrency } from '~Hooks';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import TrashIcon from '~Scenes/SelfServiceKiosks/Assets/Icons/trash.svg';

export const Item = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid rgb(238, 238, 241);
  margin: 0 24px;
  position: relative;
`;

const RoundButton = styled.div<{ color?: string }>`
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ color }) => (color ? color : 'rgb(238, 238, 241)')};
  border-radius: 8px;
`;

interface Props {
  choice: Choice;
  onRemoveUpsellItem: (id: string) => void;
}

/* Component for upsell items in the basket */
const ChoiceItem: FC<Props> = ({ choice, onRemoveUpsellItem }) => {
  const currency = useCurrency();

  return (
    <Item>
      <Row>
        <Text line={2}>{choice.name}</Text>

        <Box display="flex" alignItems="center" gap="small">
          <RoundButton onClick={() => onRemoveUpsellItem(choice.id)} color={'#e3273b'}>
            <Icon src={TrashIcon} />
          </RoundButton>
          <Price>{currency.format(choice.price)}</Price>
        </Box>
      </Row>
    </Item>
  );
};

export default ChoiceItem;
